import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TableDropdown } from '@common/components/table';
import ConfirmButton from '@common/components/confirm-button';

import type { Form } from '../../types';

type FormActionsProps = {
  item: Form;
  canDuplicate: boolean;
  onShowUpgradeModal: () => void;
  onArchive: () => void;
  onSaveAsTemplate: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onUnarchive: () => void;
};

export const FormActions = ({
  item,
  canDuplicate,
  onShowUpgradeModal,
  onArchive,
  onSaveAsTemplate,
  onDuplicate,
  onDelete,
  onUnarchive
}: FormActionsProps) => {
  const { t } = useTranslation();

  // String user must type to confirm deleting
  const confirmString = t('common:delete').toUpperCase();

  return (
    <TableDropdown>
      <TableDropdown.Item icon="folder" onClick={onSaveAsTemplate}>
        {t('forms:form_actions_create_template')}
      </TableDropdown.Item>
      <TableDropdown.Item
        icon="content_copy"
        onClick={canDuplicate ? onDuplicate : onShowUpgradeModal}
        disabled={!onDuplicate}
      >
        {t('forms:form_actions_duplicate_form')}
      </TableDropdown.Item>
      {item.status !== 'archived' && (
        <TableDropdown.Item icon="inventory" onClick={onArchive}>
          {t('forms:form_actions_archive')}
        </TableDropdown.Item>
      )}
      {
        item.status === 'archived' && (
          <TableDropdown.Item icon="unarchive" onClick={onUnarchive}>
            {t('common:unarchive')}
          </TableDropdown.Item>
        )
      }
      <ConfirmButton
        danger
        title={t('forms:form_actions_confirm_delete')}
        confirmText={t('forms:form_actions_delete_form')}
        description={(
          <Trans
            i18nKey="forms:form_actions_confirm_delete_description"
            values={{ confirmString }}
            components={[<b />]}
          />
        )}
        confirmString={confirmString}
        onConfirm={onDelete}
      >
        <TableDropdown.Item danger icon="delete">
          {t('forms:form_actions_delete_form')}
        </TableDropdown.Item>
      </ConfirmButton>
    </TableDropdown>
  );
};
